import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {Array<import('modules/statistics/types').RevenueByPeriodReducer>} */
const initialState = [];

/**
 * @param {Array<import('modules/statistics/types').RevenueByPeriodReducer>} _
 * @param {import('modules/statistics/types').FetchRevenueByPeriodStatsSuccessAction} action
 * @returns {Array<import('modules/statistics/types').RevenueByPeriodReducer>}
 */
const updateAllData = (_, { payload }) => payload.content;

/**
 * @returns {Array<import('modules/statistics/types').RevenueByPeriodReducer>}
 */
const resetData = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_REQUEST]: resetData,
  [types.FETCH_STATISTICS_REVENUE_BY_PERIOD_STATS_SUCCESS]: updateAllData,
});
